// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ebu-car-image {
  max-width: 96px;
  max-height: 64px;
  object-fit: contain;
}

.ebu-car-card {
  border-width: 1px;
}
.ebu-car-card.selected {
  border-width: 2px;
  border-color: var(--bs-primary);
}

.ebu-car-subtitle {
  font-size: 0.75rem;
  color: var(--bs-secondary-color, #6c757d);
  text-transform: uppercase;
}

.europcar-logo {
  width: 140px;
  height: 50px;
  margin-bottom: 20px;
}

@keyframes ebu-skeleton-pulse {
  0% {
    opacity: 0.6;
    background-color: var(--bs-gray-200, #e9ecef);
  }
  50% {
    opacity: 1;
    background-color: var(--bs-gray-300, #dee2e6);
  }
  100% {
    opacity: 0.6;
    background-color: var(--bs-gray-200, #e9ecef);
  }
}
.ebu-skeleton-line {
  height: 14px;
  border-radius: 4px;
  animation: ebu-skeleton-pulse 1.5s ease-in-out infinite;
}
.ebu-skeleton-line.ebu-skeleton-title {
  width: 65%;
  height: 18px;
}
.ebu-skeleton-line.ebu-skeleton-subtitle {
  width: 45%;
  height: 12px;
}
.ebu-skeleton-line.ebu-skeleton-price {
  width: 70px;
  height: 16px;
}

.ebu-skeleton-image {
  width: 96px;
  height: 54px;
  border-radius: 4px;
  animation: ebu-skeleton-pulse 1.5s ease-in-out infinite;
}

.ebu-skeleton-button {
  width: 76px;
  height: 38px;
  border-radius: 4px;
  animation: ebu-skeleton-pulse 1.5s ease-in-out infinite;
}`, "",{"version":3,"sources":["webpack://./src/app/components/layout/ebu-selection/ebu-selection.component.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;AACF;AACE;EACE,iBAAA;EACA,+BAAA;AACJ;;AAGA;EACE,kBAAA;EACA,yCAAA;EACA,yBAAA;AAAF;;AAGA;EACE,YAAA;EACA,YAAA;EACA,mBAAA;AAAF;;AAGA;EACE;IACE,YAAA;IACA,6CAAA;EAAF;EAEA;IACE,UAAA;IACA,6CAAA;EAAF;EAEA;IACE,YAAA;IACA,6CAAA;EAAF;AACF;AAGA;EACE,YAAA;EACA,kBAAA;EACA,uDAAA;AADF;AAGE;EACE,UAAA;EACA,YAAA;AADJ;AAIE;EACE,UAAA;EACA,YAAA;AAFJ;AAKE;EACE,WAAA;EACA,YAAA;AAHJ;;AAOA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uDAAA;AAJF;;AAOA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,uDAAA;AAJF","sourcesContent":[".ebu-car-image {\r\n  max-width: 96px;\r\n  max-height: 64px;\r\n  object-fit: contain;\r\n}\r\n\r\n.ebu-car-card {\r\n  border-width: 1px;\r\n\r\n  &.selected {\r\n    border-width: 2px;\r\n    border-color: var(--bs-primary);\r\n  }\r\n}\r\n\r\n.ebu-car-subtitle {\r\n  font-size: 0.75rem;\r\n  color: var(--bs-secondary-color, #6c757d);\r\n  text-transform: uppercase;\r\n}\r\n\r\n.europcar-logo {\r\n  width: 140px;\r\n  height: 50px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n@keyframes ebu-skeleton-pulse {\r\n  0% {\r\n    opacity: 0.6;\r\n    background-color: var(--bs-gray-200, #e9ecef);\r\n  }\r\n  50% {\r\n    opacity: 1;\r\n    background-color: var(--bs-gray-300, #dee2e6);\r\n  }\r\n  100% {\r\n    opacity: 0.6;\r\n    background-color: var(--bs-gray-200, #e9ecef);\r\n  }\r\n}\r\n\r\n.ebu-skeleton-line {\r\n  height: 14px;\r\n  border-radius: 4px;\r\n  animation: ebu-skeleton-pulse 1.5s ease-in-out infinite;\r\n\r\n  &.ebu-skeleton-title {\r\n    width: 65%;\r\n    height: 18px;\r\n  }\r\n\r\n  &.ebu-skeleton-subtitle {\r\n    width: 45%;\r\n    height: 12px;\r\n  }\r\n\r\n  &.ebu-skeleton-price {\r\n    width: 70px;\r\n    height: 16px;\r\n  }\r\n}\r\n\r\n.ebu-skeleton-image {\r\n  width: 96px;\r\n  height: 54px;\r\n  border-radius: 4px;\r\n  animation: ebu-skeleton-pulse 1.5s ease-in-out infinite;\r\n}\r\n\r\n.ebu-skeleton-button {\r\n  width: 76px;\r\n  height: 38px;\r\n  border-radius: 4px;\r\n  animation: ebu-skeleton-pulse 1.5s ease-in-out infinite;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
